import React from 'react';
import { Box, Container } from '@mui/material';
import Navbar from './Navbar';
import IdleSignOut from './IdleSignOut';

// App shell (YES-262): the full-width top bar, then the page in a centred container.
// The wireframes have no app footer; the public landing page brings its own. IdleSignOut signs
// out after a few minutes without activity, on every signed-in page.
const Layout = ({ children }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default' }}>
        <Navbar />
        <IdleSignOut />
        <Box component="main" sx={{ flexGrow: 1, py: { xs: 2, sm: 3 }, width: '100%' }}>
            <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3 } }}>
                {children}
            </Container>
        </Box>
    </Box>
);

export default Layout;
